import React, { useState, useEffect } from "react";
import {
  Paper, Typography, CircularProgress, Grid, TextField, Button, Link, Divider, Box, Tabs, Tab, Switch,
  Tooltip, IconButton, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Snackbar, InputAdornment,
  Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Checkbox, FormControlLabel,
} from "@mui/material";
import axios from "axios";
import utils from "../../utils";
import {
  Add as AddIcon, Remove as RemoveIcon, Upload as UploadIcon, Delete as DeleteIcon, Visibility as VisibilityIcon,
  Download as DownloadIcon, Close as CloseIcon
} from "@mui/icons-material";

const sezioni = [
  { label: "Contrattualistica", key: "contrattualistica" },
  { label: "Paghe", key: "paghe" },
  { label: "Amministrazione", key: "amministrazione" },
  { label: "Enti", key: "enti" },
  { label: "Sala Riunioni", key: "prenotasala" },
  { label: "Prenota CBA", key: "prenotacba" },
  { label: "Previsione Costi", key: "previsionecosti" },
  { label: "Guida Software", key: "guida" },
  { label: "Domande", key: "domande" },
];

const sezioniPaghe = [
  { label: "Presenze", key: "presenze" },
  { label: "Dipendenti", key: "dipendenti" },
  { label: "Timbrature", key: "timbrature" },
  { label: "Buste Paga", key: "bustepaga" },
  { label: "Malattia", key: "malattia" },
  { label: "Cassa Integrazione", key: "cassaintegrazione" },
];

const DettagliAziendaDialog = ({ id, setId }) => {
  const [azienda, setAzienda] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [isEditing, setIsEditing] = useState(false);
  const [editedAzienda, setEditedAzienda] = useState({});
  const [etichette, setEtichette] = useState([]);
  const [tabValue, setTabValue] = useState(0);
  const [aziendaFiles, setAziendaFiles] = useState([]);

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [paymentStatus, setPaymentStatus] = useState('');

  const [sortField, setSortField] = useState('');
  const [sortAsc, setSortAsc] = useState(true);
  const [fileSearchTerm, setFileSearchTerm] = useState('');
  const [allAziendaFiles, setAllAziendaFiles] = useState([]);

  // attiva disattiva
  const [openBlockDialog, setOpenBlockDialog] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [dialogAction, setDialogAction] = useState(null);
  const [dialogType, setDialogType] = useState(null);

  const [openOscuraDialog, setOpenOscuraDialog] = useState(false);
  const [oscuraAction, setOscuraAction] = useState(null);

  useEffect(() => {
    if (id) {
      loadData();
    }
  }, [id]);

  const loadData = async () => {
    try {
      const res = await axios.get("/api/me", {
        headers: utils.getAuthHeaders(),
        validateStatus: () => true,
      });
      if (res.status === 200) {
        const { success, me } = res.data;
        if (success && me.op) {
          try {
            const res = await axios.get(`/api/getuser?id=${id}`, {
              headers: utils.getAuthHeaders(),
            });
            const { success } = res.data;
            if (success) {
              setAzienda(res.data.user);
              setEditedAzienda(res.data.user);
              setEtichette(res.data.user.etichette.split(',').filter(e => e.length));
              setAllAziendaFiles(res.data.user.files || []);
              setAziendaFiles(res.data.user.files || []);
              setPaymentStatus(res.data.user.stato_pagamenti || '');
            }
          } catch (error) {
            console.log(error);
            setSnackbarMessage("Si è verificato un errore imprevisto sul nostro server.");
            setSnackbarOpen(true);
          }
          setIsLoading(false);
          return;
        }
      }
    } catch (error) {
      console.log(error);
      setSnackbarMessage("Si è verificato un errore imprevisto sul nostro server.");
      setSnackbarOpen(true);
    }
    if (process.env.REACT_APP_ENV !== "test") {
      window.location.href = "/login";
    }
    setIsLoading(false);
  };

  const handleEditClick = () => {
    setIsEditing(true);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditedAzienda({ ...editedAzienda, [name]: value });
  };

  // Funz per la conferma delle mod
  const handleConfirmClick = async () => {
    try {
      const res = await axios.post(`/api/updateutente`, { ...editedAzienda, id, etichette, paymentStatus }, {
        headers: utils.getAuthHeaders(),
      });
      const { success, error } = res.data;
      if (success) {
        return window.location.reload();
      } else {
        setSnackbarMessage(error);
        setSnackbarOpen(true);
      }
    } catch (error) {
      setSnackbarMessage("Si è verificato un errore imprevisto sul nostro server.");
      setSnackbarOpen(true);
      console.log(error);
    }
  };

  const updateVisibilita = async (visibilita) => {
    try {
      const res = await axios.post(`/api/updateutentevisibilita`, { id, visibilita }, {
        headers: utils.getAuthHeaders(),
      });
      const { success, error } = res.data;
      if (success) {
        setAzienda({ ...azienda, visibilita });
      } else {
        setSnackbarMessage(error);
        setSnackbarOpen(true);
      }
    } catch (error) {
      setSnackbarMessage("Si è verificato un errore imprevisto sul nostro server.");
      setSnackbarOpen(true);
      console.log(error);
    }
  };

  const setTimbratore = async (attivo) => {
    try {
      const res = await axios.post(`/api/abilitatimbratore`, { id, attivo }, {
        headers: utils.getAuthHeaders(),
      });
      const { success, error } = res.data;
      if (success) {
        setAzienda({ ...azienda, timbratore: attivo });
      } else {
        setSnackbarMessage(error);
        setSnackbarOpen(true);
      }
    } catch (error) {
      setSnackbarMessage("Si è verificato un errore imprevisto sul nostro server.");
      setSnackbarOpen(true);
      console.log(error);
    }
  };

  const handleConfirmTimbratoreDialog = async () => {
    setOpenDialog(false);
    const campo = dialogType === 'base' ? 'timbratore' : `timbratore_${dialogType}`;
    const attivo = dialogAction === 'attiva';

    try {
      const res = await axios.post(`/api/abilitatimbratore`, { id, type: dialogType, attivo }, {
        headers: utils.getAuthHeaders(),
      });
      const { success, error } = res.data;
      if (success) {
        setAzienda(prev => ({ ...prev, [campo]: attivo }));
      } else {
        setSnackbarMessage(error);
        setSnackbarOpen(true);
      }
    } catch (error) {
      setSnackbarMessage("Si è verificato un errore imprevisto sul nostro server.");
      setSnackbarOpen(true);
      console.log(error);
    }
  };

  // Funzione per le etichette
  const handleAddEtichetta = () => {
    setEtichette([...etichette, ""]);
  };

  const handleRemoveEtichetta = (index) => {
    const newEtichette = [...etichette];
    newEtichette.splice(index, 1);
    setEtichette(newEtichette);
  };

  const handleEtichettaChange = (e, index) => {
    const newEtichette = [...etichette];
    newEtichette[index] = e.target.value;
    setEtichette(newEtichette);
  };

  // Funz per le tabs
  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const handleToggleStatus = (type) => {
    const campo = type === 'base' ? 'timbratore' : `timbratore_${type}`;
    const action = azienda[campo] ? 'disattiva' : 'attiva';
    setDialogAction(action);
    setDialogType(type);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setOpenBlockDialog(false);
  };

  // Funz per il caricamento dei file
  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    try {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("data", JSON.stringify({
        id, name: file.name
      }));

      const res = await axios.post("/api/caricafileazienda", formData, {
        headers: {
          ...utils.getAuthHeaders(),
          "Content-Type": "multipart/form-data",
        },
      });

      const { success, error, fileId } = res.data;
      if (success) {
        const allFiles = [...allAziendaFiles, { id: fileId, name: file.name, date: new Date().toISOString() }]
        setAllAziendaFiles(allFiles);
        setAziendaFiles(allFiles);
        setFileSearchTerm('');
      } else {
        setSnackbarMessage(error);
        setSnackbarOpen(true);
      }
    } catch (err) {
      setSnackbarMessage("Errore durante il caricamento del file.");
      setSnackbarOpen(true);
    }
  };

  const handleFileDelete = async (fileId) => {
    try {
      const res = await axios.post(`/api/eliminafileazienda`, { id: fileId, aziendaId: azienda.id }, {
        headers: utils.getAuthHeaders(),
      });

      const { success, error } = res.data;
      if (success) {
        const allFiles = allAziendaFiles.filter(f => f.id != fileId);
        setAllAziendaFiles(allFiles);
        setAziendaFiles(allFiles);
        setFileSearchTerm('');
      } else {
        setSnackbarMessage(error);
        setSnackbarOpen(true);
      }
    } catch (err) {
      setSnackbarMessage("Errore durante l'eliminazione del file.");
      setSnackbarOpen(true);
    }
  };

  const handleConfirmDialog = async () => {
    setOpenBlockDialog(false);
    try {
      const res = await axios.post(`/api/bloccaazienda`, { id: azienda.id, attiva: dialogAction === 'attiva' }, {
        headers: utils.getAuthHeaders(),
      });
      const { success, error } = res.data;
      if (success) {
        setAzienda({ ...azienda, attivo: dialogAction === 'attiva' });
      } else {
        setSnackbarMessage(error);
        setSnackbarOpen(true);
      }
    } catch (error) {
      setSnackbarMessage("Si è verificato un errore imprevisto sul nostro server.");
      setSnackbarOpen(true);
      console.log(error);
    }
  };

  const handleFileSearchChange = (event) => {
    const value = event.target.value;
    setFileSearchTerm(value);
    if (value) {
      setAziendaFiles(
        allAziendaFiles.filter((file) =>
          file.name.toLowerCase().includes(value.toLowerCase())
        )
      );
    } else {
      setAziendaFiles(allAziendaFiles);
    }
  };

  const handleClearFileSearch = () => {
    setFileSearchTerm('');
    setAziendaFiles(allAziendaFiles);
  };

  // Funzione per l ordinamento
  const handleSort = (field) => {
    if (sortField === field) {
      setSortAsc(!sortAsc);
    } else {
      setSortAsc(true);
      setSortField(field);
    }

    const sortedFiles = [...aziendaFiles].sort((a, b) => {
      if (field === 'date') {
        if (sortAsc) return new Date(a[field]) > new Date(b[field]) ? 1 : -1;
        return new Date(a[field]) < new Date(b[field]) ? 1 : -1;
      } else {
        if (sortAsc) return a[field] > b[field] ? 1 : -1;
        return a[field] < b[field] ? 1 : -1;
      }
    });
    setAziendaFiles(sortedFiles);
  };

  // Dialog Oscura Buste
  const handleConfirmOscuraDialog = async () => {
    setOpenOscuraDialog(false);
    const attivo = oscuraAction === 'attiva';

    try {
      const res = await axios.post(`/api/oscurapaghe`, { id, attivo }, {
        headers: utils.getAuthHeaders(),
      });
      const { success, error } = res.data;
      if (success) {
        setAzienda({ ...azienda, oscura_paghe: attivo });
      } else {
        setSnackbarMessage(error);
        setSnackbarOpen(true);
      }
    } catch (error) {
      setSnackbarMessage("Si è verificato un errore imprevisto sul nostro server.");
      setSnackbarOpen(true);
      console.log(error);
    }
  };

  const handleAbilitaFileManager = async (attivo) => {
    try {
      const res = await axios.post(`/api/abilitafilemanager`, { id, attivo }, {
        headers: utils.getAuthHeaders(),
      });
      const { success, error } = res.data;
      if (success) {
        setAzienda({ ...azienda, file_manager: attivo });
      } else {
        setSnackbarMessage(error);
        setSnackbarOpen(true);
      }
    } catch (error) {
      setSnackbarMessage("Si è verificato un errore imprevisto sul nostro server.");
      setSnackbarOpen(true);
      console.log(error);
    }
  };

  return (
    <Dialog
      open={!!id}
      onClose={() => setId(null)}
      fullWidth
      maxWidth="xl"
      PaperProps={{ style: { borderRadius: '10px' } }}
    >
      <DialogTitle sx={{ marginBottom: 0 }}>
        <Grid item xs={12} sm={3}>
          <Box display="flex" alignItems="center" justifyContent="center">
            <Typography variant="subtitle1" sx={{ fontWeight: "bold", mr: 2 }}>
              {azienda.ragione_sociale || '...'} - <span style={{ color: azienda.attivo ? 'green' : 'red', fontWeight: 'bold' }}>
                {azienda.attivo ? ' ATTIVA' : ' DISATTIVA'}
              </span>
            </Typography>
            <Switch
              checked={azienda.attivo}
              onChange={() => {
                setDialogAction(azienda.attivo ? 'disattiva' : 'attiva');
                setOpenBlockDialog(true);
              }}
              color="success"
            />
          </Box>
        </Grid>
      </DialogTitle>
      <DialogContent
        style={{
          height: '600px',
          overflowY: 'auto',
          scrollbarWidth: 'thin',
          scrollbarColor: 'transparent transparent',
        }}
      >
        {isLoading ? (
          <CircularProgress disableShrink />
        ) : (
          <Box>

            {/* Dialog Conferma Blocca Azienda */}
            <Dialog
              open={openBlockDialog}
              onClose={handleCloseDialog}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
                Conferma {dialogAction === 'attiva' ? 'Attivazione' : 'Disattivazione'}
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  Sei sicuro di voler {dialogAction === 'attiva' ? 'attivare' : 'disattivare'} questa azienda?
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={handleCloseDialog} color="primary">
                  Annulla
                </Button>
                <Button onClick={handleConfirmDialog} color="primary" autoFocus>
                  Conferma
                </Button>
              </DialogActions>
            </Dialog>

            <Tabs
              value={tabValue}
              onChange={handleTabChange}
              variant="scrollable"
              scrollButtons="auto"
              aria-label="scrollable auto tabs example"
              orientation="horizontal"
              style={{ marginBottom: '8px' }}
            >
              <Tab label="Anagrafica" />
              <Tab label="Documenti" />
              <Tab label="Timbratore" />
              <Tab label="Autorizzazioni" />
            </Tabs>

            <Box sx={{ minHeight: '400px' }}>

              {/* Tab Anagrafica */}
              {tabValue === 0 && (
                <Grid container spacing={3}>
                  {[
                    { label: "Ragione Sociale", value: "ragione_sociale" },
                    { label: "Partita IVA", value: "partita_iva" },
                    { label: "CF Azienda", value: "cf_azienda" },
                    { label: "Email", value: "email" },
                    { label: "Nome", value: "nome" },
                    { label: "Cognome", value: "cognome" },
                    { label: "Telefono", value: "telefono" },
                    { label: "Indirizzo", value: "indirizzo" },
                    { label: "Città", value: "citta" },
                    { label: "CAP", value: "cap" },
                    { label: "Provincia", value: "provincia" },
                    { label: "PEC", value: "pec" },
                    { label: "Commercialista", value: "commercialista" },
                  ].map(({ label, value }, index) => (
                    <Grid item xs={12} sm={3} key={index}>
                      <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
                        {label}:
                      </Typography>
                      {isEditing ? (
                        <TextField
                          name={value}
                          value={editedAzienda[value] || ""}
                          onChange={handleInputChange}
                          fullWidth
                          variant="outlined"
                          sx={{ borderRadius: "8px" }}
                        />
                      ) : (
                        <Typography variant="body1">{azienda[value] || "-"}</Typography>
                      )}
                    </Grid>
                  ))}

                  {/* Stato Pagamenti */}
                  <Grid item xs={12} sm={3}>
                    <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>Status Cliente:</Typography>
                    <Box display="flex" mt={1}>
                      <Tooltip title="Regolare">
                        <IconButton
                          onClick={() => isEditing && setPaymentStatus('verde')}
                          sx={{ backgroundColor: paymentStatus === 'verde' ? 'green' : 'lightgray', borderRadius: '50%', marginRight: 1 }}
                        >
                          <span style={{ width: '10px', height: '10px', borderRadius: '50%', display: 'block' }}></span>
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Medio">
                        <IconButton
                          onClick={() => isEditing && setPaymentStatus('arancione')}
                          sx={{ backgroundColor: paymentStatus === 'arancione' ? 'orange' : 'lightgray', borderRadius: '50%', marginRight: 1 }}
                        >
                          <span style={{ width: '10px', height: '10px', borderRadius: '50%', display: 'block' }}></span>
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Rischioso">
                        <IconButton
                          onClick={() => isEditing && setPaymentStatus('rosso')}
                          sx={{ backgroundColor: paymentStatus === 'rosso' ? 'red' : 'lightgray', borderRadius: '50%' }}
                        >
                          <span style={{ width: '10px', height: '10px', borderRadius: '50%', display: 'block' }}></span>
                        </IconButton>
                      </Tooltip>
                    </Box>
                  </Grid>

                  {/* Master */}
                  <Grid item xs={12} sm={3}>
                    <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>Utente Master:</Typography>
                    {isEditing ? (
                      <Typography variant="body1">{editedAzienda.is_master ? "Sì" : "No"}</Typography>
                    ) : (
                      <Typography variant="body1">{azienda.is_master ? "Sì" : "No"}</Typography>
                    )}
                    {azienda.master && (
                      <>
                        <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>Master:</Typography>
                        <Typography variant="body1">
                          <Link href={`/op/dettaglioazienda?id=${azienda.master}`} sx={{ color: "primary.main" }}>
                            {azienda.masterName || "Master non disponibile"}
                          </Link>
                        </Typography>
                      </>
                    )}
                  </Grid>

                  {/* Etichette */}
                  <Grid item xs={12}>
                    <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>Etichetta:</Typography>
                    {isEditing ? (
                      <Grid container spacing={1} alignItems="center">
                        {etichette.map((etichetta, index) => (
                          <Grid item key={index}>
                            <Box display="flex" alignItems="center">
                              <TextField
                                name={`etichetta-${index}`}
                                value={etichetta}
                                onChange={(e) => handleEtichettaChange(e, index)}
                                variant="outlined"
                                sx={{ borderRadius: "8px", marginRight: 1 }}
                              />
                              <Button onClick={() => handleRemoveEtichetta(index)}>
                                <RemoveIcon />
                              </Button>
                            </Box>
                          </Grid>
                        ))}
                        <Grid item>
                          <Button onClick={handleAddEtichetta} variant="text" sx={{ borderRadius: "8px" }}>
                            <AddIcon />
                          </Button>
                        </Grid>
                      </Grid>
                    ) : (
                      <Typography variant="body1">{etichette.join(", ") || "Nessuna etichetta"}</Typography>
                    )}
                  </Grid>

                  {/* Note */}
                  <Grid item xs={12}>
                    <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>Note:</Typography>
                    {isEditing ? (
                      <TextField
                        name="note"
                        value={editedAzienda.note || ""}
                        onChange={handleInputChange}
                        fullWidth
                        variant="outlined"
                        sx={{ borderRadius: "8px" }}
                        multiline
                        rows={4}
                      />
                    ) : (
                      <Typography variant="body1">{editedAzienda.note || "-"}</Typography>
                    )}
                  </Grid>

                  {/* Conferma */}
                  <Grid item xs={12} sx={{ display: "flex", justifyContent: "center" }}>
                    {isEditing ? (
                      <>
                        <Button
                          onClick={() => { setIsEditing(false); setEditedAzienda(azienda); }}
                          variant="outlined"
                          color="primary"
                          sx={{ borderRadius: "8px", marginTop: "1px", marginRight: "10px" }}
                        >
                          Annulla
                        </Button>
                        <Button onClick={handleConfirmClick} variant="contained" color="primary" sx={{ borderRadius: "8px", marginTop: "1px" }}>
                          Conferma
                        </Button>
                      </>
                    ) : (
                      <Box display="flex" alignItems="center" justifyContent="center">
                        <Button onClick={handleEditClick} variant="contained" color="primary" sx={{ borderRadius: "8px", marginTop: "8px" }}>
                          Modifica
                        </Button>
                      </Box>
                    )}
                  </Grid>
                </Grid>
              )}

              {/* Tab File Azienda */}
              {tabValue === 1 && (
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <Box display="flex" alignItems="center" justifyContent="flex-start" mb={1}>
                      <Typography variant="body1" fontWeight="bold" gutterBottom style={{ margin: '8px', color: 'gray' }}>
                        File Azienda
                      </Typography>
                      <Tooltip title="Carica Documenti">
                        <IconButton
                          component="label"
                          color="primary"
                          style={{ marginRight: "10px" }}
                        >
                          <UploadIcon />
                          <input
                            type="file"
                            hidden
                            onChange={handleFileUpload}
                          />
                        </IconButton>
                      </Tooltip>
                      <TextField
                        value={fileSearchTerm}
                        onChange={handleFileSearchChange}
                        label="Cerca file"
                        variant="outlined"
                        style={{ borderRadius: '10px', marginLeft: 'auto' }}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                aria-label="clear search"
                                onClick={handleClearFileSearch}
                                edge="end"
                              >
                                {fileSearchTerm ? <CloseIcon /> : null}
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Box>
                    <TableContainer component={Paper} style={{ borderRadius: '10px', boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)' }}>
                      <Table>

                        <TableHead>
                          <TableRow style={{ backgroundColor: '#333' }}>
                            <TableCell
                              style={{ fontWeight: 'bold', cursor: 'pointer', position: 'relative', color: '#fff', textAlign: 'center' }}
                              onClick={() => handleSort('name')}
                            >
                              <Tooltip title={sortField === 'name' && sortAsc ? "Ordina per Nome Decrescente" : "Ordina per Nome Crescente"} placement="top">
                                <span>
                                  Nome File {sortField === 'name' ? (sortAsc ? '▲' : '▼') : ''}
                                </span>
                              </Tooltip>
                            </TableCell>
                            <TableCell
                              style={{ fontWeight: 'bold', cursor: 'pointer', position: 'relative', color: '#fff', textAlign: 'center' }}
                              onClick={() => handleSort('date')}
                            >
                              <Tooltip title={sortField === 'date' && sortAsc ? "Ordina per Data Meno Recente" : "Ordina per Data Più Recente"} placement="top">
                                <span>
                                  Data Inserimento {sortField === 'date' ? (sortAsc ? '▲' : '▼') : ''}
                                </span>
                              </Tooltip>
                            </TableCell>
                            <TableCell style={{ fontWeight: 'bold', color: '#fff', textAlign: 'center' }}>Azioni</TableCell>
                          </TableRow>
                        </TableHead>

                        <TableBody>
                          {aziendaFiles.map((file) => (
                            <TableRow key={file.id}>
                              <TableCell style={{ width: '33.33%', textAlign: 'center' }}>{file.name}</TableCell>
                              <TableCell style={{ width: '33.33%', textAlign: 'center' }}>{new Date(file.date).toLocaleDateString()}</TableCell>
                              <TableCell style={{ width: '33.33%', textAlign: 'center' }}>
                                <Tooltip title="Visualizza">
                                  <IconButton disabled={!file.name.endsWith('.pdf')} onClick={() => utils.opOpenPdfInNewTab(file.id)} color="primary">
                                    <VisibilityIcon />
                                  </IconButton>
                                </Tooltip>
                                <Tooltip title="Scarica">
                                  <IconButton onClick={() => utils.opDownload(file.id)} color="success">
                                    <DownloadIcon />
                                  </IconButton>
                                </Tooltip>
                                <Tooltip title="Elimina">
                                  <IconButton onClick={() => handleFileDelete(file.id)} color="error">
                                    <DeleteIcon />
                                  </IconButton>
                                </Tooltip>
                              </TableCell>
                            </TableRow>
                          ))}
                          {aziendaFiles.length === 0 && (
                            <TableRow>
                              <TableCell colSpan={3} align="center" style={{ textAlign: 'center' }}>
                                Nessun file caricato.
                              </TableCell>
                            </TableRow>
                          )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Grid>
                </Grid>
              )}

              {/* Tab Timbratore */}
              {tabValue === 2 && (
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <Typography variant="subtitle2" sx={{ color: "gray", fontStyle: "italic", mb: 2 }}>
                      Seleziona una delle opzioni disponibili per attivare il timbratore associato a questa azienda.
                      Una volta attivato, l'azienda potrà configurare una password per ogni dipendente nel loro profilo personale.
                      I dipendenti utilizzeranno il codice timbratore e la relativa password per registrare le presenze.

                      Nel frattempo, l'azienda avrà accesso alla sezione dedicata dove potrà monitorare timbrature, eventi, comunicazioni
                      e richieste in tempo reale.
                    </Typography>
                  </Grid>

                  <Grid item xs={12} sm={6} md={4}>
                    <Box display="flex" flexDirection="column" gap={2}>
                      {[
                        { label: "Timbratore Base", key: "base", description: "Attiva il timbratore e le richieste di timbratura" },
                        { label: "Timbratore Eventi", key: "eventi", description: "Include gli eventi e le comunicazioni" },
                        { label: "Timbratore Cedolini", key: "cedolini", description: "Include i cedolini per il dipendente" },
                      ].map(({ label, key, description }) => (
                        <Box key={key} display="flex" alignItems="center" justifyContent="space-between">
                          <Box>
                            <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>{label}</Typography>
                            <Typography variant="body2" color="text.secondary">{description}</Typography>
                          </Box>
                          <Switch
                            checked={azienda[key === 'base' ? 'timbratore' : `timbratore_${key}`]}
                            onClick={(e) => {
                              e.preventDefault(); // blocca il comportamento automatico
                              handleToggleStatus(key);
                            }}
                            color="primary"
                          />
                        </Box>
                      ))}
                    </Box>
                  </Grid>
                </Grid>
              )}

              {/* Dialog di Conferma Timbratore */}
              <Dialog
                open={openDialog}
                onClose={handleCloseDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
              >
                <DialogTitle id="alert-dialog-title">
                  {`Conferma ${dialogAction === 'attiva' ? 'Attivazione' : 'Disattivazione'} Timbratore ${dialogType === 'base' ? 'Base' : dialogType === 'eventi' ? 'Eventi' : 'Cedolini'}`}
                </DialogTitle>
                <DialogContent>
                  <DialogContentText id="alert-dialog-description">
                    {`Sei sicuro di voler ${dialogAction === 'attiva' ? 'attivare' : 'disattivare'} il timbratore ${dialogType === 'base' ? 'Base' : dialogType === 'eventi' ? 'Eventi' : 'Cedolini'} per questa azienda?`}
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button onClick={handleCloseDialog} color="primary">
                    Annulla
                  </Button>
                  <Button onClick={handleConfirmTimbratoreDialog} color="primary" autoFocus>
                    Conferma
                  </Button>
                </DialogActions>
              </Dialog>

              {/* Tab Autorizzazioni */}
              {tabValue === 3 && (
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <Typography variant="subtitle2" sx={{ color: "gray", fontStyle: "italic", mb: 2 }}>
                      In questa sezione puoi oscurare le buste paga disponibili da scaricare per il cliente e riattivarle nel momento in cui paga.
                      Il cliente avrà le buste disponibili da scaricare ma saranno oscurate nel momento in cui scarica i PDF o lo ZIP dei PDF finché non gli viene sbloccato a seguito di un pagamento.
                      Una volta sbloccato, potrà scaricarle non oscurate tranquillamente.
                    </Typography>
                  </Grid>

                  <Grid item xs={12} sm={6} md={4}>
                    <Box display="flex" alignItems="center" justifyContent="space-between">
                      <Box>
                        <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>Oscura Buste</Typography>
                        <Typography variant="body2" color="text.secondary">Potrà scaricare le buste ma oscurate</Typography>
                      </Box>
                      <Switch
                        checked={azienda.oscura_paghe || false}
                        onChange={(e) => {
                          const action = e.target.checked ? 'attiva' : 'disattiva';
                          setOscuraAction(action);
                          setOpenOscuraDialog(true);
                        }}
                        color="primary"
                      />
                    </Box>
                  </Grid>

                  <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />

                  <Grid item xs={12} sm={6} md={4}>
                    <Box display="flex" alignItems="center" justifyContent="space-between">
                      <Box>
                        <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>Abilita File Manager</Typography>
                        <Typography variant="body2" color="text.secondary">Potrà usare il file manager per archiviare i file aziendali</Typography>
                      </Box>
                      <Switch
                        checked={azienda.file_manager || false}
                        onChange={(e) => {
                          const nuovoValore = e.target.checked;
                          handleAbilitaFileManager(nuovoValore);
                        }}
                        color="primary"
                      />
                    </Box>
                  </Grid>

                  <Grid item xs={12}>
                    <Typography variant="body1" sx={{ fontWeight: "bold", mt: 0 }}>
                      Sezioni Concesse
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 0 }}>
                      Potrà vedere le sezioni selezionate
                    </Typography>
                  </Grid>

                  <Grid container item spacing={0}>
                    {sezioni.map(({ label, key }) => (
                      <Grid item xs={12} sm={6} md={3} key={key}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={azienda.visibilita == 'all' || azienda.visibilita.split(',').map(v => v.split(':')[0]).includes(key)}
                              onChange={(e) => {
                                if (azienda.visibilita == 'all') {
                                  if (!e.target.checked) {
                                    updateVisibilita(sezioni.filter(s => s.key != key).map(s => `${s.key}:*`).join(','));
                                  }
                                } else {
                                  let splitted = azienda.visibilita.split(',');
                                  if (e.target.checked && !splitted.map(v => v.split(':')[0]).includes(key)) {
                                    splitted.push(`${key}:*`);
                                  } else if (!e.target.checked && splitted.map(v => v.split(':')[0]).includes(key)) {
                                    splitted = splitted.filter(v => v.split(':')[0] != key);
                                  }
                                  updateVisibilita(splitted.join(','));
                                }
                              }}
                              color="primary"
                            />
                          }
                          label={label}
                        />
                      </Grid>
                    ))}
                  </Grid>

                  <Grid item xs={12}>
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 0 }}>
                      Sottosezioni Paghe
                    </Typography>
                  </Grid>

                  <Grid container item spacing={0}>
                    {sezioniPaghe.map(({ label, key }) => (
                      <Grid item xs={12} sm={6} md={3} key={key}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={azienda.visibilita == 'all' ||
                                (azienda.visibilita.split(',').map(v => v.split(':')[0]).includes('paghe') &&
                                  (azienda.visibilita.split(',').filter(v => v.split(':')[0] == 'paghe')[0].split(':')[1] == '*' ||
                                    azienda.visibilita.split(',').filter(v => v.split(':')[0] == 'paghe')[0].split(':')[1].split('|').includes(key)))}
                              onChange={(e) => {
                                const currentPaghe = azienda.visibilita.split(',').filter(v => v.split(':')[0] == 'paghe')[0];
                                const splitted = azienda.visibilita.split(',').filter(v => v.split(':')[0] != 'paghe');
                                if (!currentPaghe) {
                                  if (e.target.checked) {
                                    splitted.push(`paghe:${key}`);
                                  }
                                } else if (currentPaghe.split(':')[1] == '*') {
                                  if (!e.target.checked) {
                                    splitted.push(`paghe:${sezioniPaghe.filter(s => s.key != key).map(s => s.key).join('|')}`);
                                  }
                                } else {
                                  let splitted2 = currentPaghe.split(':')[1].split('|');
                                  if (e.target.checked && !splitted2.includes(key)) {
                                    splitted2.push(key);
                                    if (splitted2.length == sezioniPaghe.length) {
                                      splitted2 = ['*'];
                                    }
                                  } else if (!e.target.checked && splitted2.includes(key)) {
                                    splitted2 = splitted2.filter(v => v != key);
                                  }
                                  splitted.push(`paghe:${splitted2.join('|')}`);
                                }
                                updateVisibilita(splitted.join(','));
                              }}
                              color="primary"
                            />
                          }
                          label={label}
                        />
                      </Grid>
                    ))}
                  </Grid>

                </Grid>
              )}

              {/* Dialog di Conferma Oscura Paghe */}
              <Dialog
                open={openOscuraDialog}
                onClose={() => setOpenOscuraDialog(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
              >
                <DialogTitle id="alert-dialog-title">
                  Conferma {oscuraAction === 'attiva' ? 'Attivazione' : 'Disattivazione'} Oscuramento Buste
                </DialogTitle>
                <DialogContent>
                  <DialogContentText id="alert-dialog-description">
                    Sei sicuro di voler {oscuraAction === 'attiva' ? 'attivare' : 'disattivare'} l'oscuramento delle buste paga per questa azienda?
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button onClick={() => setOpenOscuraDialog(false)} color="primary">
                    Annulla
                  </Button>
                  <Button onClick={handleConfirmOscuraDialog} color="primary" autoFocus>
                    Conferma
                  </Button>
                </DialogActions>
              </Dialog>

            </Box>
          </Box>
        )}

        <Snackbar
          open={snackbarOpen}
          autoHideDuration={6000}
          onClose={() => setSnackbarOpen(false)}
          message={snackbarMessage}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setId(null)} color="primary">Chiudi</Button>
      </DialogActions>
    </Dialog>
  );
};

export default DettagliAziendaDialog;
